import {useMutation} from "@tanstack/react-query";
import {toast} from "sonner";

import {TOAST_CONFIG} from "@/lib/constansts";
import {useInvalidate} from "@/src/modules/core/hooks";
import {captureParkingSubmitError} from "@/src/modules/core/lib/glitchtip/parking-capture";

import type {AmenityConfig} from "../lib/amenity-config";
import {getAccessLogService} from "../lib/registry";

type UseAmenityAccessLogCreateParams = {
  config: AmenityConfig;
  onSuccess?: () => void;
};

export default function useAmenityAccessLogCreate({
  config,
  onSuccess,
}: UseAmenityAccessLogCreateParams) {
  const service = getAccessLogService(config);
  const invalidateSingular = useInvalidate(config.accessLogPath);
  const invalidatePlural = useInvalidate(config.accessLogsSectionKey);

  return useMutation({
    mutationFn: (data: Record<string, unknown>) => service.createAccessLog(data),
    retry: false,
    onSuccess: () => {
      invalidateSingular();
      invalidatePlural();
      toast.success(`${config.labelAccessLogs} created successfully`, TOAST_CONFIG);
      onSuccess?.();
    },
    onError: (error) => {
      captureParkingSubmitError(error, {
        feature: config.guestRuleFeature,
        operation: `amenity_access_log_${config.type}_create`,
      });
    },
  });
}
